export class BillingType {
  id?: number;
  label?: string;

  constructor(data = {}) {
    Object.assign(this, data);
  }
}
